var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56859 2.00971L16.5 0L14.7748 7.00763L12.6225 4.9415L9.15087 8.55783C9.03301 8.6806 8.87018 8.75 8.7 8.75C8.52982 8.75 8.36699 8.6806 8.24913 8.55783L5.7 5.90249L1.95087 9.80783C1.71182 10.0568 1.31618 10.0649 1.06717 9.82587C0.818161 9.58682 0.810087 9.19117 1.04913 8.94217L5.24913 4.56717C5.36699 4.4444 5.52982 4.375 5.7 4.375C5.87018 4.375 6.03301 4.4444 6.15087 4.56717L8.7 7.22251L11.7208 4.07584L9.56859 2.00971Z",
    fill: "url(#paint0_linear_1610_8478)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1610_8478",
    x1: 0.875,
    y1: 5.1504,
    x2: 16.5,
    y2: 5.1504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f6b42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f6b42"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.78fab32a76165b8ade1b9695fe0b43a3.svg";
export { ForwardRef as ReactComponent };